<template>
    <div style="position:relative;display:grid;grid-template-columns: auto auto auto auto auto auto auto auto auto;grid-template-rows: 60px;background: #ddd;padding-left:70px;">
        <div style="position:absolute;left:20px;top:0px">
         <v-checkbox
            v-model="selected"
            @change="onChange_selectAll"
        />
        </div>
        <span style="font-size: 1rem; margin: 0; color: #666;display: flex;align-items: center;">
            Chain
        </span>
        <span style="font-size: 1rem; margin: 0; color: #666;display: flex;align-items: center;">
            Date
        </span>
        <span style="font-size: 1rem; margin: 0; color: #666;display: flex;align-items: center;">
            DOW
        </span>
        <span style="font-size: 1rem; margin: 0; color: #666;display: flex;align-items: center;">
            A/C
        </span>
        <span style="font-size: 1rem; margin: 0; color: #666;display: flex;align-items: center;">
            Flight No.
        </span>
        <span style="font-size: 1rem; margin: 0; color: #666;display: flex;align-items: center;">
            Airport
        </span>
        <span style="font-size: 1rem; margin: 0; color: #666;display: flex;align-items: center;">
            Slot
        </span>
        <span style="font-size: 1rem; margin: 0; color: #666;display: flex;align-items: center;">
            Warnings
        </span>
        <span style="font-size: 1rem; margin: 0; color: #666;display: flex;align-items: center;">
            Status
        </span>
    </div>
</template>

<script>
    import { eventBus } from '../../../../../main';
    export default {
        name: 'SelectedFlightListHeader',

        /* >>> *************************************************************** / /* Props */
        props: {

            editorMode: String

        }, // eo props{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data() {

            return {
                selected: true
            };

        }, // eo data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
        created: function () {

            const me = this;


            me.$toc('>>> views/flights/slotmanagement/components/shared/SelectedFlightListHeader.vue >>> created');

        }, // eo function created()



        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
        destroyed: function () {

            const me = this;


            me.$toc('>>> views/flights/slotmanagement/components/shared/SelectedFlightListHeader.vue >>> destroyed');

        }, // eo function destroyed()



        /* >>> *************************************************************** / /* Methods */
        methods: {

            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
            onChange_selectAll: function (value) {

                const me = this;

                eventBus.$emit('selectallflightsfromheader', me.selected);
            }

        } // eo methods{}
        /* <<< ****************************************************************/
    };
</script>
